<template>
  <div class="text-xs-center">
    <v-dialog v-model="show" width="1000">
      <v-card>
        <v-card-title class="headline" primary-title>
          Documentos Adjuntos
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <div v-for="item in attachments" :key="item.asset.id">
            <a class="light-blue--text" :href="item.asset.url" target="_blank">{{ item.asset.name }}</a>
            <span>: {{ item.asset.description || '- sin descripción -' }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    attachments: Array
  },

  data () {
    return {
      show: false
    }
  },

  methods: {
    showDialog () {
      this.show = true
    }
  }
}
</script>
